module.exports = __webpack_public_path__ + "templates.category_filter-59acb964.html";